<template>
  <div class="page page--order-confirmed order-confirmed">
    <div class="page__block" v-if="loading">
      <h2>{{ $t("paymentcompleted.loading") }}</h2>
    </div>

    <div
      class="page__block"
      v-else-if="!loading && error"
    >
      <h2>{{ $t("paymentcompleted.errorTitle") }}</h2>
      <p>
        {{ $t("paymentcompleted.errorText") }}
      </p>
      <p>
        {{ $t("backto") }}
        <router-link
          v-if="travelagent"
          :to="{
            name: 'Home',
            query: {
              TALIC: talic,
              UID: uid,
              TAEMAIL: taEmail,
              TANAME: taName,
              AGENT: travelagent,
            },
          }"
          >Home</router-link
        >
        <router-link v-else to="/">Home</router-link>
      </p>
    </div>

    <div
      class="page__block"
      v-else-if="!loading && paymentStatus && paymentStatus.paymentStatusCategory === 'SUCCESSFUL'"
    >
      <h2>{{ $t("orderconfirm.title") }}</h2>
      <p>
        {{ $t("orderconfirm.text") }}
      </p>
      <p><b>{{ paymentStatus ? paymentStatus.merchantReference: "" }}</b> - <b>{{ paymentStatus ? paymentStatus.paymentStatusCategory: "" }}</b></p>
      <p>{{ $t("orderconfirm.info") }}</p>
      <p>
        {{ $t("backto") }}
        <router-link
          v-if="travelagent"
          :to="{
            name: 'Home',
            query: {
              TALIC: talic,
              UID: uid,
              TAEMAIL: taEmail,
              TANAME: taName,
              AGENT: travelagent,
            },
          }"
          >Home</router-link
        >
        <router-link v-else to="/">Home</router-link>
      </p>
    </div>
<div class="page__block" v-else-if="!loading && paymentStatus && paymentStatus.paymentStatusCategory !== 'SUCCESFUL'">
      <h2>{{ $t("orderfailed.title") }}</h2>
      <p>{{ $t("orderfailed.text") }}</p>

      <p><b>{{ paymentStatus ? paymentStatus.merchantReference: "" }}</b> - <b>{{ paymentStatus ? paymentStatus.paymentStatusCategory: "" }}</b></p>
      <p>
        {{ $t("backto") }}
        <router-link
          v-if="travelagent"
          :to="{
            name: 'Home',
            query: {
              TALIC: talic,
              UID: uid,
              TAEMAIL: taEmail,
              TANAME: taName,
              AGENT: travelagent,
            },
          }"
          >Home</router-link
        >
        <router-link v-else to="/">Home</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import PaymentService from "../services/payment";

export default {
  name: "OrderConfirmed",
  data() {
    return {
      hostedCheckoutId: this.$route.query.hostedCheckoutId,
      loading: true,
      paymentStatus: null,
      error: false,
      talic: this.$route.query.TALIC,
      uid: this.$route.query.UID,
      taEmail: this.$route.query.TAEMAIL,
      taName: this.$route.query.TANAME,
      travelagent: this.$route.query.AGENT,
    };
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  created() {
    if (!this.hostedCheckoutId) {
      this.$router.push("/not-found");
    } else{
        this.checkPaymentStatus();
    }
  },

  methods: {
    async checkPaymentStatus() {
      try {
        this.paymentStatus = await PaymentService.checkPaymentStatus(
          this.hostedCheckoutId,
        );
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
